import { SearchableDropdown } from './SearchableDropdown';

interface OrganizationDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function OrganizationDropdown({
  value,
  onChange,
  placeholder = 'Select Organization',
  className,
}: OrganizationDropdownProps) {
  return (
    <SearchableDropdown
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search organizations..."
      className={className}
      endpoint="organizations"
      emptyText="No organizations found."
    />
  );
}
